import React from 'react'
import SharePartList from './sharepartlist'
import { Iprops } from './sharepartlistinterface';


function SharePartListContainer(props:Iprops) {
    return (
        <SharePartList childCheckboxes={props.childCheckboxes} cartsDetails={props.cartsDetails} isMiningCart={props.isMiningCart} mininingCartData={props.mininingCartData} shareOnClick={props.shareOnClick} />
  )
}

export default SharePartListContainer